module.exports = __webpack_public_path__ + "img/hc3620_center_003.51967304.png";